<template>
  <router-view
    v-if="loaded"
  />
</template>
<script>
import { defineComponent } from 'vue'
import { mergeMessages } from 'boot/i18n'
import { useContextApplication } from 'ui-common/base/composables/useContextApplication.pinia'

import { utils } from '@wilken8-public/ds-orders-energy-events'
import { useOrderEvents } from 'ui-common/orders/composables/useOrderEvents'

export default defineComponent({
  name: 'OrdersEnergyApp',
  props: {
    isMfe: {
      type: Boolean,
      default: () => false
    }
  },
  setup (props) {
    const { loaded } = useContextApplication({
      contextOptions: {
        contextName: 'orders_energy'
      },
      mergeMessages,
      isMfe: props.isMfe
    })

    if (process.env.NODE_ENV === 'development') {
      const { namespace: eventNamespace } = useOrderEvents()
      utils.getAllKnownEventNames(eventNamespace).forEach(name => {
        console.debug(`adding event listener for: ${name}`)
        window.addEventListener(name, e => console.debug(e))
      })
    }

    return { loaded }
  }
})
</script>
